export default __webpack_public_path__ + "static/media/placeholderImg.69535fcd.jpg";